import {
    ISRESULT,
    DOWNLOAD_FILE,
    GET_DATA_NEW_PLANHANDLE, GET_DATA_NEW_PLANHANDLE_SUCCEEDED, REQUERT_NEW_PLANHANDLE_FAILED, SET_DATA_NEW_PLANHANDLE, UPLOAD_FILE_PLANHANDLE,UPLOAD_FILE_PLANHANDLE_SUCCEEDED,
    GET_DATA_PLANHANDLE_PLANHANDLE, GET_DATA_PLANHANDLE_PLANHANDLE_SUCCEEDED, REQUERT_PLANHANDLE_PLANHANDLE_FAILED, SET_DATA_PLANHANDLE_PLANHANDLE,CLEAR_DATA_NEW_PLANHANDLE,
    GET_DATA_PLANHANDLESTEP_PLANHANDLE, GET_DATA_PLANHANDLESTEP_PLANHANDLE_SUCCEEDED, REQUERT_PLANHANDLESTEP_PLANHANDLE_FAILED, SET_DATA_PLANHANDLESTEP_PLANHANDLE, SET_DATA_PLANHANDLESTEP_PLANHANDLE_SUCCEEDED,CLEAR_DATA_PLANHANDLESTEP_PLANHANDLE,
    GET_DATA_FILTERREPORT_PLANTYPE, GET_DATA_FILTERREPORT_PLANTYPE_SUCCEEDED, REQUEST_FILTERREPORT_PLANTYPE_FAILED, CLEAR_DATA_FILTERREPORT_PLANTYPE,
    GET_DATA_TABLEREPORT_PLANHANDLE, GET_DATA_TABLEREPORT_PLANHANDLE_SUCCEEDED, REQUEST_DATA_TABLEREPORT_PLANHANDLE_FAILED, CLEAR_DATA_TABLEREPORT_PLANHANDLE,
    GET_DATA_HEADER_TABLEREPORT_PLANHANDLE, GET_DATA_HEADER_TABLEREPORT_PLANHANDLE_SUCCEEDED, REQUEST_DATA_HEADER_TABLEREPORT_PLANHANDLE_FAILED, CLEAR_DATA_HEADER_TABLEREPORT_PLANHANDLE,
    GET_DATA_HISTORY, GET_DATA_HISTORY_SUCCEEDED, REQUERT_DATA_HISTORYE_FAILED,GET_DATA_STATUS_ACTION_HISTORY, GET_DATA_STATUS_ACTION_HISTORY_SUCCEEDED, GET_DATA_STATUS_ACTION_HISTORY_FAILED,
    GET_DATA_ACTION_LinkApi,GET_DATA_ACTION_LinkApi_SUCCEEDED,GET_DATA_ACTION_LinkApi_FAILED,
    GET_DATA_ACTION_LinkApibyid,GET_DATA_ACTION_LinkApibyid_SUCCEEDED,GET_DATA_ACTION_LinkApibyid_FAILED,
    GET_DATA_EMAIL_AZURE, GET_DATA_EMAIL_AZURE_SUCCEEDED, REQUEST_DATA_EMAIL_AZURE_FAILED, GET_DATA_VALIDATE_DATE, GET_DATA_VALIDATE_DATE_SUCCEEDED, REQUEST_GET_DATA_VALIDATE_DATE_FAILED, GET_DATA_PLAN_BY_PASS, REQUEST_DATA_PLAN_BY_PASS_FAILED, GET_DATA_PLAN_BY_PASS_SUCCEEDED

    //IndexImportHygen
} from './actionTypes';

export const IsResultAction = (isResult) => {
    return {
        type: ISRESULT,
        isResult: isResult
    }
}

//NewPlanHandle
export const GetDataNewPlanHandleAction = (ID, PlanID) => {
    return {
        id: ID,
        planID: PlanID,
        type: GET_DATA_NEW_PLANHANDLE
    }
}
export const GetDataNewPlanHandleSuccessAction = (DataNew) => {
    return {
        type: GET_DATA_NEW_PLANHANDLE_SUCCEEDED,
        DataNew: DataNew
    }
}
export const RequertNewPlanHandleFaileAction = (Err) => {
    return {
        type: REQUERT_NEW_PLANHANDLE_FAILED,
        err: Err
    }
}
export const SetDataNewPlanHandleAction = (DataNew) => {
    return {
        type: SET_DATA_NEW_PLANHANDLE,
        DataNew: DataNew
    }
}
export const ClearDataNewPlanHandleAction = () => {
    return {
        type: CLEAR_DATA_NEW_PLANHANDLE
    }
}
export const UploadFilePlanHandleAction = (File, Index) => {
    return {
        type: UPLOAD_FILE_PLANHANDLE,
        file: File,
        index: Index
    }
}
export const UploadFilePlanHandleSuccessAction = (File, Index) => {
    return {
        type: UPLOAD_FILE_PLANHANDLE_SUCCEEDED,
        file: File,
        index: Index
    }
}
//PlanHandlePlanHandle
export const GetDataPlanHandlePlanHandleAction = (DataPlanHandle) => {
    return {
        type: GET_DATA_PLANHANDLE_PLANHANDLE,
        DataPlanHandle: DataPlanHandle
    }
}
export const GetDataPlanHandlePlanHandleSuccessAction = (DataPlanHandle) => {
    return {
        type: GET_DATA_PLANHANDLE_PLANHANDLE_SUCCEEDED,
        DataPlanHandle: DataPlanHandle
    }
}
export const RequertPlanHandlePlanHandleFaileAction = (Err) => {
    return {
        type: REQUERT_PLANHANDLE_PLANHANDLE_FAILED,
        err: Err
    }
}
export const SetDataPlanHandlePlanHandleAction = (DataPlanHandle) => {
    return {
        type: SET_DATA_PLANHANDLE_PLANHANDLE,
        DataPlanHandle: DataPlanHandle
    }
}
//PlanHandleStepPlanHandle
export const GetDataPlanHandleStepPlanHandleAction = (ID, Step) => {
    return {
        id: ID,
        step: Step,
        type: GET_DATA_PLANHANDLESTEP_PLANHANDLE
    }
}
export const GetDataPlanHandleStepPlanHandleSuccessAction = (DataPlanHandleStep) => {
    return {
        type: GET_DATA_PLANHANDLESTEP_PLANHANDLE_SUCCEEDED,
        DataPlanHandleStep: DataPlanHandleStep
    }
}
export const SetDataPlanHandleStepSuccessAction = (DataHandleStaff) => {
    return {
        type: SET_DATA_PLANHANDLESTEP_PLANHANDLE_SUCCEEDED,
        DataHandleStaff: DataHandleStaff
    }
}

export const RequertPlanHandleStepPlanHandleFaileAction = (Err) => {
    return {
        type: REQUERT_PLANHANDLESTEP_PLANHANDLE_FAILED,
        err: Err
    }
}
export const SetDataPlanHandleStepPlanHandleAction = (DataPlanHandleStep) => {
    return {
        type: SET_DATA_PLANHANDLESTEP_PLANHANDLE,
        DataPlanHandleStep: DataPlanHandleStep
    }
}
export const ClearDataPlanHandleStepPlanHandleAction = () => {
    return {
        type: CLEAR_DATA_PLANHANDLESTEP_PLANHANDLE
    }
}

export const DownloadFileAction = (value) => {
    return {
        type: DOWNLOAD_FILE,
        value: value
    }
}

//Filter Report

export const GetFilterReportHandleAction = (ID) => {
    return {
        id: ID,
        type: GET_DATA_FILTERREPORT_PLANTYPE
    }
}

export const GetFilterReportHandleSuccessAction = (DataFilterReport) => {
    return {
        type: GET_DATA_FILTERREPORT_PLANTYPE_SUCCEEDED,
        DataFilterReport: DataFilterReport
    }
}

export const RequestFilterReportHandleFaileAction = (Err) => {
    return {
        type: REQUEST_FILTERREPORT_PLANTYPE_FAILED,
        err: Err
    }
}

export const ClearDataFilterReportHandleAction = () => {
    return {
        type: CLEAR_DATA_FILTERREPORT_PLANTYPE
    }
}

//Data Table Report

export const GetDataTableReportHandleAction = (ID, DataTables) => {
    return {
        id: ID,
        dataTables: DataTables,
        type: GET_DATA_TABLEREPORT_PLANHANDLE
    }
}

export const GetDataTableReportHandleSuccessAction = (DataTableReport) => {
    return {
        type: GET_DATA_TABLEREPORT_PLANHANDLE_SUCCEEDED,
        DataTableReport: DataTableReport
    }
}

export const RequestTableReportHandleFaileAction = (Err) => {
    return {
        type: REQUEST_DATA_TABLEREPORT_PLANHANDLE_FAILED,
        err: Err
    }
}

export const GetDataHistory = (planID) => {
    return {
        planID: planID,
        type: GET_DATA_HISTORY
    }
}


export const GetDataHistorySuccessAction = (DataHistory) => {
    return {
        type:  GET_DATA_HISTORY_SUCCEEDED,
        DataHistory: DataHistory
    }
}


export const GetDataHistoryFaileAction = (Err) => {
    return {
        type: REQUERT_DATA_HISTORYE_FAILED,
        err: Err
    }
}

export const ClearDataTableReportHandleAction = () => {
    return {
        type: CLEAR_DATA_TABLEREPORT_PLANHANDLE
    }
}

//Data Header Table Report

export const GetDataHeaderTableReportHandleAction = (ID, DataTables) => {
    return {
        id: ID,
        dataTables: DataTables,
        type: GET_DATA_HEADER_TABLEREPORT_PLANHANDLE
    }
}

export const GetDataHeaderTableReportHandleSuccessAction = (DataHeaderTableReport) => {
    return {
        type: GET_DATA_HEADER_TABLEREPORT_PLANHANDLE_SUCCEEDED,
        DataHeaderTableReport: DataHeaderTableReport
    }
}

export const RequestHeaderTableReportHandleFaileAction = (Err) => {
    return {
        type: REQUEST_DATA_HEADER_TABLEREPORT_PLANHANDLE_FAILED,
        err: Err
    }
}

export const ClearDataHeaderTableReportHandleAction = () => {
    return {
        type: CLEAR_DATA_HEADER_TABLEREPORT_PLANHANDLE
    }
}

//Get status action history

export const GetStatusActionHistory = (planID) => {
    //console.log("action/GetStatusActionHistory", planID);
    return {
        planID: planID,
        type: GET_DATA_STATUS_ACTION_HISTORY
    }
}


export const GetStatusActionHistorySuccess = (StatusActionHistory) => {
    return {
        type:  GET_DATA_STATUS_ACTION_HISTORY_SUCCEEDED,
        StatusActionHistory: StatusActionHistory
    }
}


export const GetStatusActionHistoryFailed = (Err) => {
    return {
        type: GET_DATA_STATUS_ACTION_HISTORY_FAILED,
        err: Err
    }
}

//Get link api data

export const GetDataLinkApiAction = (DataLinkApi) => {
    return {
        DataLinkApi: DataLinkApi,
        type: GET_DATA_ACTION_LinkApi
    }
}
export const GetDataLinkApiSuccess = (DataLinkApi) => {
    return {
        type:  GET_DATA_ACTION_LinkApi_SUCCEEDED,
        DataLinkApi: DataLinkApi
    }
}
export const GetDataLinkApiFailed = (Err) => {
    return {
        type: GET_DATA_ACTION_LinkApi_FAILED,
        err: Err
    }
}

//Get link api byid data

export const GetDataLinkApibyidAction = (DataLinkApibyid) => {
    return {
        DataLinkApibyid: DataLinkApibyid,
        type: GET_DATA_ACTION_LinkApibyid
    }
}
export const GetDataLinkApibyidSuccess = (DataLinkApibyid) => {
    return {
        type:  GET_DATA_ACTION_LinkApibyid_SUCCEEDED,
        DataLinkApibyid: DataLinkApibyid
    }
}
export const GetDataLinkApibyidFailed = (Err) => {
    return {
        type: GET_DATA_ACTION_LinkApibyid_FAILED,
        err: Err
    }
}

// get Azure Email Address
export const GetDataEmailAzureAction = (DataEmailAzure) =>{
    return {
        DataEmailAzure: DataEmailAzure,
        type: GET_DATA_EMAIL_AZURE
    }
}

export const GetDataEmailAzureSuccessAction = (DataEmailAzure) =>{
    return{
        type: GET_DATA_EMAIL_AZURE_SUCCEEDED,
        DataEmailAzure: DataEmailAzure
    }
}

export const RequestDataEmailAzureActionFailed = (Err)=>{
    return{
        type: REQUEST_DATA_EMAIL_AZURE_FAILED,
        err: Err
    }
}

//GetValidateDate
export const GetDataValidateDateAction = (DataValidate) =>{
    return {
        DataValidate: DataValidate,
        type: GET_DATA_VALIDATE_DATE
    }
}

export const GetDataValidateDateSuccessAction = (DataValidate) =>{
    return{
        type: GET_DATA_VALIDATE_DATE_SUCCEEDED,
        DataValidate: DataValidate
    }
}

export const RequestDataValidateDateActionFailed = (Err)=>{
    return{
        type: REQUEST_GET_DATA_VALIDATE_DATE_FAILED,
        err: Err
    }
}
//GetPlanByPassCreate
export const GetDataPlanByPassAction = () =>{
    return {
        type: GET_DATA_PLAN_BY_PASS
    }
}
export const GetDataPlanByPassSuccessAction = (DataPlan) =>{
    return {
        type: GET_DATA_PLAN_BY_PASS_SUCCEEDED,
        DataPlan: DataPlan
    }
}
export const RequestDataPlanByPassFailedAction = (Err)=>{
    return{
        type: REQUEST_DATA_PLAN_BY_PASS_FAILED,
        err: Err
    }
}
//IndexUsingHygen